type LogLevel = 'info' | 'warn' | 'error' | 'debug';

interface LogEntry {
  level: LogLevel;
  message: string;
  data?: any;
  timestamp: string;
}

class LoggerService {
  private static instance: LoggerService;
  private isDev = import.meta.env.DEV;

  private constructor() {}

  static getInstance(): LoggerService {
    if (!LoggerService.instance) {
      LoggerService.instance = new LoggerService();
    }
    return LoggerService.instance;
  }

  private log(level: LogLevel, message: string, data?: any) {
    const entry: LogEntry = {
      level,
      message,
      data,
      timestamp: new Date().toISOString(),
    };

    if (this.isDev) {
      const style = {
        info: 'color: #3b82f6',
        warn: 'color: #eab308',
        error: 'color: #ef4444',
        debug: 'color: #a855f7',
      };
      
      console.groupCollapsed(`%c[${level.toUpperCase()}] ${message}`, style[level]);
      if (data) console.log(data);
      console.log(`Timestamp: ${entry.timestamp}`);
      console.groupEnd();
    } else {
      // In production, this would send to Sentry/LogRocket/Datadog
      // implementation placeholder
      console.log(`[${level.toUpperCase()}] ${message}`, data);
    }
  }

  info(message: string, data?: any) {
    this.log('info', message, data);
  }

  warn(message: string, data?: any) {
    this.log('warn', message, data);
  }

  error(message: string, error?: Error | any) {
    this.log('error', message, {
      error,
      stack: error?.stack,
    });
  }

  debug(message: string, data?: any) {
    this.log('debug', message, data);
  }
}

export const logger = LoggerService.getInstance();
